<template>
  <img
    src="/images/close.svg"
    loading="lazy"
    alt=""
    class="names__close LKIconClose"
    @click="$emit('close')"
  >
</template>

<script>
export default {
  name: 'LKIconClose',
  props: {
    count: Number,
  },
}
</script>

<style lang="scss">
.LKIconClose {
  color: $webflow-color-black;
  transition: transform 0.3s ease;

  &:hover {
    transform: rotate(180deg);
  }
}
</style>
